import Vue from "vue";
import Vuex from "vuex";
import moduleToast from "./moduleToast";
import moduleUser from "./moduleUser";
import moduleMentalHealth from "./moduleMentalHealth";
import moduleProfessional from "./moduleProfessional";
import moduleConsultation from "./shedule/moduleConsultation";
import moduleSchedule from "./shedule/moduleSchedule";
import moduleSelectedConsultation from "./shedule/moduleSelectedConsultation";
import moduleSelectedTypeConsultation from "./shedule/moduleSelectedTypeConsultation";
import moduleLockedDay from "./shedule/moduleLockedDay";
import moduleLoader from "./moduleLoader";
import moduleDaySelected from "./shedule/moduleDaySelected";
import moduleScheduleDetail from "./shedule/moduleScheduleDetail";
import moduleSelectedPatient from "./shedule/moduleSelectedPatient";
import moduleSpecialty from "./general/moduleSpecialty";
import moduleCivilStatus from "./general/moduleCivilStatus";
import moduleCommune from "./general/moduleCommune";
import moduleConvPrev from "./general/moduleConvPrev";
import moduleCountry from "./general/moduleCountry";
import moduleEthnicGroup from "./general/moduleEthnicGroup";
import moduleGender from "./general/moduleGender";
import moduleIdentificationType from "./general/moduleIdentificationType";
import moduleIntPrev from "./general/moduleIntPrev";
import moduleNationality from "./general/moduleNationality";
import moduleProvince from "./general/moduleProvince";
import moduleRegion from "./general/moduleRegion";
import moduleSex from "./general/moduleSex";
import moduleSamples from "./patientData/moduleSamples";
import modulePatient from "./patientData/modulePatient";
import moduleRecipeAps from "./patientData/moduleRecipeAps";
import moduleEpi from "./patientData/moduleEpi";
import moduleQx from "./patientData/moduleQx";
import moduleIc from "./patientData/moduleIc";
import moduleCie10 from "./general/moduleCie10";
import moduleNode from "./general/moduleNode";
import moduleContraref from "./patientData/moduleContraref";
import moduleSelectedServiceNode from "./shedule/moduleSelectedService";
import moduleSelectedConsultationType from "./shedule/moduleSelectedConsultationType";
import moduleScheduleCitation from "./shedule/moduleScheduleCitation";
import moduleUserSession from "./moduleUserSession";
import exportModuleTeleOpi from "./teleopi/moduleTeleOpi";
import exportModulesInterconsults from "./interconsults/moduleStoreInterconsults";
import moduleCreatePatientState from "./moduleCreatePatientState";
import moduleRecipe from "./mentalHealth/moduleRecipe";
import moduleInterconsult from "./interconsults/moduleInterconsultsWithoutAppointment";
import moduleRecipeOtherNodes from "@/store/patientData/moduleRecipeOtherNodes";
import moduleScheduleCitationArchive from "./shedule/moduleScheduleCitationArchive";
import moduleControlOrder from "@/store/controlOrder/moduleControlOrder";
import moduleSelectedDateSchedule from "@/store/shedule/moduleSelectedDateSchedule";
import moduleErrorLog from "@/store/general/moduleErrorLog";
import moduleMedicalAdmission from "@/store/mentalHealth/moduleMedicalAdmission";
import moduleActiveTabCreateAdmission from "@/store/medicalAdmission/moduleActiveTabCreateAdmission";
import moduleModuleFile from "@/store/general/moduleModuleFile";
import moduleBenefit from "@/store/general/moduleBenefit";

import moduleLocation from "./shedule/moduleLocation";
import moduleServiceNode from "./shedule/moduleServiceNode";
import moduleTeiLog from "@/store/general/moduleTeiLog";
import moduleSoapLog from "@/store/general/moduleSoapLog";
import moduleJob from "@/store/general/moduleJob";
import modulePrescriptionPad from "./modulePrescriptionPad";
import moduleSideMenu from "./general/moduleSideMenu";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    toast: moduleToast,
    loader: moduleLoader,
    users: moduleUser,
    mentalHealth: moduleMentalHealth,
    professionals: moduleProfessional,
    userSession: moduleUserSession,
    createPatientState: moduleCreatePatientState,
    interconsults: exportModulesInterconsults,
    medicalAdmission: moduleMedicalAdmission,
    moduleFile: moduleModuleFile,
    //Store teleopi	SONO CHI NO SADAME!!!!
    teleOpi: exportModuleTeleOpi,

    specialties: moduleSpecialty,
    civilStatuses: moduleCivilStatus,
    communes: moduleCommune,
    convPrevs: moduleConvPrev,
    countries: moduleCountry,
    ethnicGroups: moduleEthnicGroup,
    genders: moduleGender,
    identificationTypes: moduleIdentificationType,
    intPrevs: moduleIntPrev,
    nationalities: moduleNationality,
    provinces: moduleProvince,
    regions: moduleRegion,
    sexs: moduleSex,
    samples: moduleSamples,
    patient: modulePatient,
    recipesAps: moduleRecipeAps,
    epis: moduleEpi,
    qxs: moduleQx,
    ics: moduleIc,
    cie10: moduleCie10,
    contraref: moduleContraref,

    /////
    //Store Agenda :3
    consultation: moduleConsultation,
    schedule: moduleSchedule,
    lockedDay: moduleLockedDay,
    daySelected: moduleDaySelected,
    scheduleDetail: moduleScheduleDetail,
    scheduleCitation: moduleScheduleCitation,
    selectedConsultation: moduleSelectedConsultation,
    selectedTypeConsultation: moduleSelectedTypeConsultation,
    selectedPatient: moduleSelectedPatient,
    selectedServiceNode: moduleSelectedServiceNode,
    selectedConsultationType: moduleSelectedConsultationType,
    selectedDateSchedule: moduleSelectedDateSchedule,
    recipeMentalHealth: moduleRecipe,
    controlOrder: moduleControlOrder,

    recipesOtherNodes: moduleRecipeOtherNodes,
    nodes: moduleNode,

    location: moduleLocation,
    service_node: moduleServiceNode,

    // archive
    scheduleCitationArchive: moduleScheduleCitationArchive,

    errorLog: moduleErrorLog,
    activeTabCreateAdmission: moduleActiveTabCreateAdmission,

    medicalBenefit: moduleBenefit,
    teiLog: moduleTeiLog,
    soapLog: moduleSoapLog,
    job: moduleJob,
    prescriptionPad: modulePrescriptionPad,

    sideMenu: moduleSideMenu,
  },
});

export default store;
